// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-card-long {
	position: relative;
	background-color: rgba(137, 116, 186, 0.13);
	border-radius: 8px;
	border: 1px solid rgba(137, 116, 186, 0.6);
	max-height: 230px;
}
.active-task-card-long {
	position: relative;
	background-color: rgba(137, 116, 186, 0.13);
	border-radius: 8px;
	border: 1px solid rgba(137, 116, 186, 0.6);
	max-height: 230px;
}
.task-card {
	position: relative;
	background-color: rgba(137, 116, 186, 0.13);
	border-radius: 8px;
	border: 1px solid rgba(137, 116, 186, 0.6);
	max-height: 200px;
	max-width: 350px;
	min-width: 350px;
}
.active-task-card {
	position: relative;
	background-color: #effff1;
	border-radius: 8px;
	border: 1px solid rgba(38, 191, 25, 0.23);
	max-height: 200px;
	max-width: 350px;
	min-width: 350px;
}
.active-task-card #description {
	color: gray;
}
.active-task-card-long #description {
	color: gray;
}
.task-card-long #description {
	color: gray;
}
.task-card #description {
	color: gray;
}
.active-button {
	border-radius: 84px;
	background-color: #d2ffd6;
	width: 100px;
	height: 30px;
	display: flex;
	align-items: center;
	place-content: center;
	border: 1px solid rgba(38, 191, 25, 0.23);
	position: absolute;
	bottom: -15px;
	left: 50%;
	transform: translateX(-50%);
	/* cursor: pointer; */
	color:#26BF19;
}
.select-button {
	border-radius: 84px;
	background-color: rgba(255, 255, 255, 1);
	width: 100px;
	height: 30px;
	display: flex;
	align-items: center;
	place-content: center;
	border: 1px solid rgba(29, 157, 206, 1);
	position: absolute;
	bottom: -15px;
	left: 50%;
	transform: translateX(-50%);
	cursor: pointer;
	color:#1D9DCE;
}
.active-button-top-right {
	border-radius: 84px;
	background-color: #d2ffd6;
	width: 100px;
	height: 30px;
	display: flex;
	align-items: center;
	place-content: center;
	border: 1px solid rgba(38, 191, 25, 0.23);
	position: absolute;
	top: -15px;
	right: 25px;
	/* transform: translateX(-50%); */
	/* cursor: pointer; */
	color:#26BF19;
}
.select-button-top-right {
	border-radius: 84px;
	background-color: rgba(255, 255, 255, 1);
	width: 100px;
	height: 30px;
	display: flex;
	align-items: center;
	place-content: center;
	border: 1px solid rgba(29, 157, 206, 1);
	position: absolute;
	top: -15px;
	right: 25px;
	cursor: pointer;
	color:#1D9DCE;
}
@media only screen and (max-width: 600px) {
	.active-card {
		margin-bottom: 20px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/main/dashboards/knowledge_base/ai-agent-card/ai-agent-card.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,kBAAkB;CAClB,0CAA0C;CAC1C,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,kBAAkB;CAClB,0CAA0C;CAC1C,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,kBAAkB;CAClB,0CAA0C;CAC1C,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,yCAAyC;CACzC,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,yCAAyC;CACzC,kBAAkB;CAClB,aAAa;CACb,SAAS;CACT,2BAA2B;CAC3B,qBAAqB;CACrB,aAAa;AACd;AACA;CACC,mBAAmB;CACnB,wCAAwC;CACxC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,SAAS;CACT,2BAA2B;CAC3B,eAAe;CACf,aAAa;AACd;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,yCAAyC;CACzC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,iCAAiC;CACjC,qBAAqB;CACrB,aAAa;AACd;AACA;CACC,mBAAmB;CACnB,wCAAwC;CACxC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,uCAAuC;CACvC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,eAAe;CACf,aAAa;AACd;AACA;CACC;EACC,mBAAmB;CACpB;AACD","sourcesContent":[".task-card-long {\n\tposition: relative;\n\tbackground-color: rgba(137, 116, 186, 0.13);\n\tborder-radius: 8px;\n\tborder: 1px solid rgba(137, 116, 186, 0.6);\n\tmax-height: 230px;\n}\n.active-task-card-long {\n\tposition: relative;\n\tbackground-color: rgba(137, 116, 186, 0.13);\n\tborder-radius: 8px;\n\tborder: 1px solid rgba(137, 116, 186, 0.6);\n\tmax-height: 230px;\n}\n.task-card {\n\tposition: relative;\n\tbackground-color: rgba(137, 116, 186, 0.13);\n\tborder-radius: 8px;\n\tborder: 1px solid rgba(137, 116, 186, 0.6);\n\tmax-height: 200px;\n\tmax-width: 350px;\n\tmin-width: 350px;\n}\n.active-task-card {\n\tposition: relative;\n\tbackground-color: #effff1;\n\tborder-radius: 8px;\n\tborder: 1px solid rgba(38, 191, 25, 0.23);\n\tmax-height: 200px;\n\tmax-width: 350px;\n\tmin-width: 350px;\n}\n.active-task-card #description {\n\tcolor: gray;\n}\n.active-task-card-long #description {\n\tcolor: gray;\n}\n.task-card-long #description {\n\tcolor: gray;\n}\n.task-card #description {\n\tcolor: gray;\n}\n.active-button {\n\tborder-radius: 84px;\n\tbackground-color: #d2ffd6;\n\twidth: 100px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tplace-content: center;\n\tborder: 1px solid rgba(38, 191, 25, 0.23);\n\tposition: absolute;\n\tbottom: -15px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\t/* cursor: pointer; */\n\tcolor:#26BF19;\n}\n.select-button {\n\tborder-radius: 84px;\n\tbackground-color: rgba(255, 255, 255, 1);\n\twidth: 100px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tplace-content: center;\n\tborder: 1px solid rgba(29, 157, 206, 1);\n\tposition: absolute;\n\tbottom: -15px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tcursor: pointer;\n\tcolor:#1D9DCE;\n}\n.active-button-top-right {\n\tborder-radius: 84px;\n\tbackground-color: #d2ffd6;\n\twidth: 100px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tplace-content: center;\n\tborder: 1px solid rgba(38, 191, 25, 0.23);\n\tposition: absolute;\n\ttop: -15px;\n\tright: 25px;\n\t/* transform: translateX(-50%); */\n\t/* cursor: pointer; */\n\tcolor:#26BF19;\n}\n.select-button-top-right {\n\tborder-radius: 84px;\n\tbackground-color: rgba(255, 255, 255, 1);\n\twidth: 100px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tplace-content: center;\n\tborder: 1px solid rgba(29, 157, 206, 1);\n\tposition: absolute;\n\ttop: -15px;\n\tright: 25px;\n\tcursor: pointer;\n\tcolor:#1D9DCE;\n}\n@media only screen and (max-width: 600px) {\n\t.active-card {\n\t\tmargin-bottom: 20px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
